export default {
  isDevelopment: process.env.NODE_ENV !== 'production',
  isProduction: process.env.NODE_ENV === 'production',
  isStaging: process.env.REACT_APP_IS_STAGING ? JSON.parse(process.env.REACT_APP_IS_STAGING) : false,
  debug: process.env.REACT_APP_DEBUG ? JSON.parse(process.env.REACT_APP_DEBUG) : false,
  apiUrl: process.env.REACT_APP_API_URL,
  defaultLocale: process.env.REACT_APP_DEFAULT_LOCALE,
  dataProtectionUrl: process.env.REACT_APP_DATA_PROTECTION_URL || 'https://www.hyponoe.at/datenschutz',
  impressumUrl: process.env.REACT_APP_IMPRESSUM_URL || 'https://www.hyponoe.at/impressum',
  graphqlServerUrl: process.env.REACT_APP_GRAPHQL_SERVER_URL,
  dsn: process.env.REACT_APP_DSN,
  enuPartnerLink: process.env.REACT_APP_ENU_PARTNER_URL,
  applicationType: process.env.REACT_APP_APPLICATION_TYPE,
};
